import { StyledHeaderWrapper, StyledHeaderInner } from './styles'
import HeaderLogo from './HeaderLogo'
import HeaderLinks from './HeaderLinks'
import AccountMenu from 'components/AccountMenu/HeaderAccountMenu'
import MobileMenu from 'components/MobileMenu'

function Header() {
  return (
    <StyledHeaderWrapper shouldHaveBg>
      <StyledHeaderInner>
        <HeaderLogo />
        <HeaderLinks />
        <AccountMenu />
        <MobileMenu />
      </StyledHeaderInner>
    </StyledHeaderWrapper>
  )
}

export default Header
